import {Template} from "./template.js";
import {qrCode, stopQR} from "./qrCode.js";
import {Page4_addmodem} from "../component.js";

const Form_window = {
    name: 'Form_window',

    
    template: Template,

    data(){
        return{
            selected_phone:[],
            phones_array:[],
            message: '',
            modem: null,
            description: '',
            description_coords: '',
            types: [
                {
                    key: 'serial',
                    info: '',
                    typefield:  'text',
                    namelabel: this.$t('addModem.serialNumber'),
                },
                {
                    key: 'full_serial',
                    info:'',
                    typefield:  'text',
                    namelabel: this.$t('addModem.fullSerial'),
                 },
                 {
                    key: 'tube_name',
                    info:'',
                    typefield:  'text',
                    namelabel: this.$t('addModem.tubeName'),
                 }   
              ],
              comment_types:[
                {
                    info:'',
                    typefield:  'text',
                    namelabel: this.$t('addModem.modemComment'),
                },
                {
                    info:'',
                    typefield:  'text',
                    namelabel: this.$t('addModem.tubeComment'),
                }, 
              ],
            
            modem_coords: '[27.6845492,53.94454554]',
            tube_coords: '[27.6845492,53.94454554] [27.68945452,53.94454542]',
        }
    },

    created(){
        this.selected_phone=this.selected_phones;
        //qrCode();
    },

    destroyed() {
        //stopQR();
    },

    computed:{
        validModem(){
            for(let i=0; i<this.types.length; i++){
                if(!this.validInput(this.types[i].info)){
                    return true;
                }
            }
            if(!this.validCoords(this.modem_coords) || !this.validCoords(this.tube_coords)){
                return true;
            }
            else if(this.selected_phone.length==0){
                return true;
            }
            else{
                return false;
            }
        },
    },
    updated() {
		this.types[0].namelabel = this.$t('addModem.serialNumber');
        this.types[1].namelabel = this.$t('addModem.fullSerial');
        this.types[2].namelabel = this.$t('addModem.tubeName');
        this.comment_types[0].namelabel = this.$t('addModem.modemComment');
        this.comment_types[1].namelabel = this.$t('addModem.tubeComment');
	},
    props: {
		tubes: Array,
        phones: Array,
        selected_phones: Array
    },

    methods:{

        validInput(element){
            this.description = this.$t('addModem.message1');
            return element.length > 0 ? true : false;
        },

        //при вводе проверяем валидность координат, чтобы при отправке формы не было записано null
        validCoords(element){
            let regEx=/\d+[\.,]?\d*/g;
            if(element!=''){
                if(element.match(regEx)!=null){
                    return true;
                }
                //если введены некоректные данные
                else{
                    this.description_coords=this.$t('addModem.message2');
                    return false;
                }
            }
            else{
                return true;
            }
        },

        //методы для всплывающего окна сообщения
        showModal() {
            this.$refs['messageModal'].show()
        },

        hideModal() {
            this.$emit('updateTubeList');	
            this.$refs['messageModal'].hide()
        },

        //добавляем модем без очистки полей
        createAndContinue(){
            let cont = this;
            this.modem={ serial: this.types[0].info,
                         full_serial: this.types[1].info, 
                         tube_name: this.types[2].info,
                         modem_comment: this.comment_types[0].info,
                         tube_comment: this.comment_types[1].info,
                         type: 'NB-IOT',
                         modem_coordinates: Page4_addmodem.methods.get_coordinates(this.modem_coords),
                         tube_coordinates: Page4_addmodem.methods.get_coordinates(this.tube_coords),
                         phones: this.get_phones(),
                        };

            const message3 = this.$t('addModem.message3');
            const message4 = this.$t('addModem.message4');
            this.$API('modems', 'addModemTube', this.modem, 
            function(data){
                if(data.element=="exist"){
                    cont.message=message3;
                }
                else{
                    cont.message=message4;
                }
                cont.showModal();
            },
            function(errorText){
                console.log(errorText)
            });
        },
        
        //метод добавления с очисткой полей от данных
        createAndDelete(){
            this.createAndContinue();
            //чистим поля
            this.types.forEach(element => {
                element.info='';
            });
        },

        get_phones(){
            this.phones_array;
            for(let i=0; i<this.selected_phone.length; i++){
                this.phones_array[i]={ "phone": this.selected_phone[i] };
            }
            return JSON.stringify(this.phones_array);
        },

        checkAllPhones(){
            this.selected_phone=[];
            for (let key in this.phones){
                this.selected_phone.push(this.phones[key].value);
            }
        },

        deleteAllPhones(){
            this.selected_phone=[];
        },
    },
}
export { Form_window }


// WEBPACK FOOTER //
// ./src/app/js/components/page4_addmodem/form_window/component.js